import { render } from "./Loyalty2023.vue?vue&type=template&id=2db5306a"
import script from "./Loyalty2023.vue?vue&type=script&lang=js"
export * from "./Loyalty2023.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__